module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Heavy-7c23ddbe19a13c26aef8fd49e37adfc5.ttf";